import React from 'react'
import { FormControl, FormErrorMessage, FormHelperText, Input } from '@chakra-ui/react'

interface FormInputProps {
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
  type?: string;
  name: string;
  displayText: string;
  placeholder: string;
  required: boolean;
  error?: boolean;
  errorMessage?: string;
  bg?: string;
  as?: any;
  mask?: string;
  maskChar?: string,
  testId?: string;
}

const FormInput: React.FC<FormInputProps> = ({
  value,
  displayText,
  name,
  placeholder,
  required,
  onChange = () => null,
  onBlur = () => null, 
  onFocus = () => null,
  maxLength = 100, 
  type = 'text', 
  error = false, 
  errorMessage = '', 
  bg = 'white', 
  as = '',
  mask = '',
  maskChar = null,
  testId = ''
  }) => (
    <FormControl isInvalid={error}>
      <FormHelperText className='form-helper-text'>{displayText}</FormHelperText>
      <Input
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        className='form-input'
        maxLength={maxLength}
        type={type}
        name={name}
        placeholder={placeholder}
        required={required}
        bg={bg}
        as={as}
        mask={mask}
        maskChar={maskChar}
        data-testid={testId}
      />
      {error && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </FormControl>
  )

export default FormInput
